import { watchOnce } from '@vueuse/core';
import { useNavKillswitch } from '~/stores/navKillswitch';
import { storeToRefs } from 'pinia';

export default function onPropertiesReady(cb, _store) {
  const navKillswitch = useNavKillswitch();
  const { isProperties } = storeToRefs(navKillswitch);

  if (isProperties.value) {
    cb();
    return;
  }

  watchOnce(isProperties, cb);
}
